// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import MembersPage from './pages/MembersPage';
import PublicationsPage from './pages/PublicationsPage';
import ProjectsPage from './pages/ProjectsPage';
import ExpertisePage from './pages/ExpertisePage';
import MemberPage from './pages/MemberPage'; 
import ThesisPage from './pages/ThesisPage'; 
import './styles/Navbar.css';
import './styles/Footer.css';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/members" element={<MembersPage />} />
            <Route path="/publications" element={<PublicationsPage />} />
            <Route path="/expertise" element={<ExpertisePage />} />
            <Route path="/thesis" element={<ThesisPage />} /> {/* New Thesis Page route */}
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/member-preview" element={<MemberPage />} /> {/* New Member Page route */}
            <Route path="/members" element={<MembersPage />} />
            <Route path="/members/:id" element={<MemberPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
